module.exports = __webpack_public_path__ + "img/bild3.130248eb.png";